import PlanificadorTareaService from 'src/modules/planificadorTarea/planificadorTareaService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PLANIFICADORTAREA_VIEW';

const planificadorTareaViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: planificadorTareaViewActions.FIND_STARTED,
      });

      const record = await PlanificadorTareaService.find(id);

      dispatch({
        type: planificadorTareaViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: planificadorTareaViewActions.FIND_ERROR,
      });

      getHistory().push('/planificador-tarea');
    }
  },
};

export default planificadorTareaViewActions;
